import { watchDeleteCashDiscount } from './deleteCashDiscount';
import { watchDeleteProgramGroup } from './deleteProgramGroup';
import { watchDeleteProgramLevel } from './deleteProgramLevel';
import { watchFetchCashDiscounts } from './fetchCashDiscounts';
import { watchFetchProgramPreSeasonSetup } from './fetchPreSeasonSetup';
import { watchFetchPrograms } from './fetchPrograms';
import { watchQueryCashDiscounts } from './queryCashDiscounts';
import { watchUpdateCashDiscount } from './updateCashDiscount';
import { watchUpdateProgramGroup } from './updateProgramGroup';
import { watchUpdateProgramLevel } from './updateProgramLevel';
import { watchUpdateProgramPreSeasonSetup } from './updateProgramPreSeasonSetup';

export const programsSagas = [
  watchDeleteCashDiscount(),
  watchDeleteProgramGroup(),
  watchDeleteProgramLevel(),
  watchFetchCashDiscounts(),
  watchFetchProgramPreSeasonSetup(),
  watchFetchPrograms(),
  watchUpdateCashDiscount(),
  watchUpdateProgramGroup(),
  watchUpdateProgramLevel(),
  watchUpdateProgramPreSeasonSetup(),
  watchQueryCashDiscounts()
];
